import { render } from "./MovieCont.vue?vue&type=template&id=6213de50&scoped=true"
import script from "./MovieCont.vue?vue&type=script&lang=js"
export * from "./MovieCont.vue?vue&type=script&lang=js"

import "./MovieCont.vue?vue&type=style&index=0&id=6213de50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6213de50"]])

export default __exports__